var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('back-button'),_c('page-header',[_vm._v(_vm._s(_vm.user.name))]),_c('user-form',{attrs:{"user":_vm.user,"self":true},on:{"submit":_vm.submitForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }